import * as Actions from './types';
import {
  getCustomersApi,
  getUnrReadMsgsCountApi,
  sendMessageApi,
} from '../../api/communication/communication-apis';
import { deleteCustomerApi } from '../../api/customer/customer-api';
import { Toast } from '../../components/Toast/Toast';

export const getCustomerChats = (query) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_CUSTOMER_CHATS_REQUEST,
    });

    const {
      data: { data },
    } = await getCustomersApi(query);

    dispatch({
      type: Actions.GET_CUSTOMER_CHATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_CUSTOMER_CHATS_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendMessage = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEND_NEW_MESSAGE_REQUEST,
    });

    const {
      data: { data },
    } = await sendMessageApi(payload);

    dispatch({
      type: Actions.SEND_NEW_MESSAGE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SEND_NEW_MESSAGE_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteChat = (customerId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_CHAT_REQUEST,
    });

    const {
      data: { data },
    } = await deleteCustomerApi(customerId);

    dispatch({
      type: Actions.DELETE_CHAT_SUCCESS,
      payload: data,
    });
    Toast('success', 'Contact Deleted Successfully');
  } catch (error) {
    dispatch({
      type: Actions.DELETE_CHAT_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// all msgs
export const getUnreadMsgsCount = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_UNREAD_COUNT_REQUEST,
    });

    const {
      data: { data },
    } = await getUnrReadMsgsCountApi();

    dispatch({
      type: Actions.GET_UNREAD_COUNT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_UNREAD_COUNT_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
